import { getCurrentUser } from "aws-amplify/auth";

/** True when Amplify already has a signed-in Cognito user in this browser. */
export async function refreshSessionState(): Promise<boolean> {
  try {
    await getCurrentUser();
    return true;
  } catch {
    return false;
  }
}
